import initialState from './initialState'
import { AnyAction } from 'redux'
import { InvestmentsActionTypes, InvestmentsState } from './types'

export default function investmentReducer(
  state = initialState,
  action: AnyAction
): InvestmentsState {
  switch (action.type) {
    case InvestmentsActionTypes.CREATE_ACCOUNT:
      return {
        ...state,
        isLoading: true
      }
    case InvestmentsActionTypes.SET_LOADING:
      return {
        ...state,
        isLoading: true
      }
    case InvestmentsActionTypes.DISMISS_LOADING:
      return {
        ...state,
        isLoading: false
      }
    case InvestmentsActionTypes.SET_INVESTMENT_BALANCE:
      return {
        ...state,
        investedBalance: action.payload
      }
    case InvestmentsActionTypes.SET_PERFORMANCE:
      return {
        ...state,
        performance: action.payload
      }
    case InvestmentsActionTypes.GET_TUTORIAL_COMPLETION_PENDING:
      return {
        ...state,
        isLoading: true,
        isTutorialLoading: true
      }
    case InvestmentsActionTypes.GET_TUTORIAL_COMPLETION_FULFILLED:
      return {
        ...state,
        tutorialCompleted: action.payload,
        isLoading: initialState.isLoading,
        isTutorialLoading: initialState.isTutorialLoading
      }
    case InvestmentsActionTypes.GET_TUTORIAL_COMPLETION_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: initialState.isLoading,
        isTutorialLoading: initialState.isTutorialLoading
      }
    case InvestmentsActionTypes.GET_IS_TUTORIAL_COMPLETED_PENDING:
      return {
        ...state,
        isLoading: true
      }
    case InvestmentsActionTypes.GET_IS_TUTORIAL_COMPLETED_FULFILLED:
      return {
        ...state,
        tutorialCompleted: action.payload,
        isLoading: initialState.isLoading
      }
    case InvestmentsActionTypes.GET_IS_TUTORIAL_COMPLETED_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: initialState.isLoading
      }
    case InvestmentsActionTypes.GET_INVESTMENT_CLIENT_PENDING:
      return {
        ...state,
        isLoading: true,
        investmentClientLoading: true
      }
    case InvestmentsActionTypes.GET_INVESTMENT_CLIENT_FULFILLED:
      return {
        ...state,
        investmentClient: action.payload,
        isLoading: initialState.isLoading,
        investmentClientLoading: initialState.investmentClientLoading
      }
    case InvestmentsActionTypes.GET_INVESTMENT_CLIENT_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: initialState.isLoading,
        investmentClientLoading: initialState.investmentClientLoading
      }
    case InvestmentsActionTypes.LOGOUT:
      return {
        ...initialState
      }
    case InvestmentsActionTypes.SET_SUBSCRIPTION_PENDING:
      return {
        ...state,
        isLoading: true
      }
    case InvestmentsActionTypes.SET_SUBSCRIPTION_FULFILLED:
      return {
        ...state,
        isLoading: initialState.isLoading
      }
    case InvestmentsActionTypes.SET_SUBSCRIPTION_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: initialState.isLoading
      }
    case InvestmentsActionTypes.SET_RESCUE_PENDING:
      return {
        ...state,
        isLoading: true
      }
    case InvestmentsActionTypes.SET_RESCUE_FULFILLED:
      return {
        ...state,
        isLoading: initialState.isLoading
      }
    case InvestmentsActionTypes.SET_RESCUE_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: initialState.isLoading
      }
    case InvestmentsActionTypes.GET_HOLDING_ACCOUNT_PENDING:
      return {
        ...state,
        loadingHoldingAccount: true
      }
    case InvestmentsActionTypes.GET_HOLDING_ACCOUNT_FULFILLED:
      return {
        ...state,
        isBalanceHoldingError: false,
        balanceHoldingAccount: action.payload,
        loadingHoldingAccount: initialState.loadingHoldingAccount
      }
    case InvestmentsActionTypes.GET_HOLDING_ACCOUNT_REJECTED:
      return {
        ...state,
        isError: true,
        isBalanceHoldingError: true,
        balanceHoldingAccount: initialState.balanceHoldingAccount,
        loadingHoldingAccount: initialState.loadingHoldingAccount
      }
    case InvestmentsActionTypes.GET_LAST_PERFORMANCE_PENDING:
      return {
        ...state,
        isLoading: true
      }
    case InvestmentsActionTypes.GET_LAST_PERFORMANCE_FULFILLED:
      return {
        ...state,
        lastPerformance: action.payload.percentual_diff,
        isLoading: initialState.isLoading
      }
    case InvestmentsActionTypes.GET_LAST_PERFORMANCE_REJECTED:
      return {
        ...state,
        isError: true,
        lastPerformance: initialState.lastPerformance,
        isLoading: initialState.isLoading
      }
    case InvestmentsActionTypes.GET_ORDERS_PENDING: {
      return {
        ...state,
        isLoading: true
      }
    }
    case InvestmentsActionTypes.GET_ORDERS_FULFILLED: {
      return {
        ...state,
        isLoading: initialState.isLoading,
        orders: action.payload
      }
    }
    case InvestmentsActionTypes.GET_ORDERS_REJECTED: {
      return {
        ...state,
        isLoading: initialState.isLoading
      }
    }
    case InvestmentsActionTypes.GET_FUND_PENDING:
      return {
        ...state,
        isLoading: true
      }
    case InvestmentsActionTypes.GET_FUND_FULFILLED:
      return {
        ...state,
        isLoading: initialState.isLoading,
        fund: action.payload
      }
    case InvestmentsActionTypes.GET_FUND_REJECTED:
      return {
        ...state,
        isLoading: initialState.isLoading
      }
    case InvestmentsActionTypes.GET_INVESTMENT_PARAMS_PENDING:
      return {
        ...state,
        isLoading: true,
        isParamsLoading: true
      }
    case InvestmentsActionTypes.GET_INVESTMENT_PARAMS_FULFILLED:
      return {
        ...state,
        isLoading: initialState.isLoading,
        isParamsLoading: initialState.isParamsLoading,
        investmentHolidays: action.payload.holidays,
        investmentHours: action.payload.investmentHours,
        authorization: action.payload.authorized
      }
    case InvestmentsActionTypes.GET_INVESTMENT_PARAMS_REJECTED:
      return {
        ...state,
        isLoading: initialState.isLoading,
        isParamsLoading: initialState.isParamsLoading
      }
    case InvestmentsActionTypes.SET_CANCEL_INVESTMENT_ORDER_PENDING:
      return {
        ...state,
        isLoading: true
      }
    case InvestmentsActionTypes.SET_CANCEL_INVESTMENT_ORDER_FULFILLED:
      return {
        ...state,
        isLoading: initialState.isLoading
      }
    case InvestmentsActionTypes.SET_CANCEL_INVESTMENT_ORDER_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: initialState.isLoading
      }
    case InvestmentsActionTypes.SET_SELECT_INVESTMENT_ORDER: {
      return {
        ...state,
        selected: action.payload
      }
    }
    default:
      return state
  }
}
